import { QuestionnaireTextAreaQuestion } from '@pm/graphql';
import i18n from 'i18next';
import * as Yup from 'yup';

export const textAreaQuestionSchema = ({
  maxLength,
  minLength,
}: QuestionnaireTextAreaQuestion) =>
  Yup.string()
    .max(maxLength, () =>
      i18n.t('Validations.String.Maximum', {
        ns: 'global',
        count: maxLength,
      }),
    )
    .min(minLength, () =>
      i18n.t('Validations.String.Minimum', {
        ns: 'global',
        count: minLength,
      }),
    );
